import { useEffect, useState } from "react"
import { Box, Typography, LinearProgress, useTheme } from "@mui/material"
import { useOrder } from "context/OrderContext"
import { Check } from "@mui/icons-material"
import "./style.css";
import CustomTypography from "components/Fileds/CustomTypography";
import React from 'react'

const OrderSuccessDialog = ({open, onClose, id}) => {
    const { resetOrder } = useOrder()
    const theme = useTheme();

  const [progress, setProgress] = useState(0)

  // Generate a random order ID
  const orderId = id

  // Auto-close logic stays the same
  useEffect(() => {
    if (!open) return
    setProgress(0)
    const timer = setInterval(() => {
      setProgress((old) => {
        const next = old + 2
        if (next >= 100) {
          clearInterval(timer)
          setTimeout(() => {
            resetOrder()
            onClose()
          }, 200)
        }
        return next
      })
    }, 50)
    return () => {
      clearInterval(timer)
       if (orderId) {
        // safety: only reset if an order was created
        onClose()
      }
    }
  }, [open, onClose, resetOrder, orderId])

  // Don’t render anything when closed
  if (!open) return null
   // Render the exact same content, just wrapped in a Box instead of Dialog
  return (
    <Box className='sucess-order-container'>
      <CustomTypography
        variant="body1"
        label={"Order ID"}
        color="text.secondary"
        sx={{mb:1}}
      />
      <CustomTypography
        variant={"h6"}
        sx={{mb:3, color: theme.palette.drawermenuitem.main, fontWeight: 400}}
        label={orderId}
      />
      <Box className='check-circle-icon'>
        <Check fontSize="large" htmlColor="#27AE60" />
      </Box>

      <Typography variant="h6" color="#27AE60" fontWeight="bold" sx={{ mb: 0.5 }}>
        Order Created
      </Typography>
      <Typography variant="h6" color="#27AE60" fontWeight="bold" sx={{ mb: 3 }}>
        Successfully!
      </Typography>

      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 8,
          borderRadius: 4,
          bgcolor: "rgba(39, 174, 96, 0.2)",
          "& .MuiLinearProgress-bar": {
            bgcolor: "#27AE60",
          },
        }}
      />
    </Box>
  )
}

export default OrderSuccessDialog
